import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder } from '@angular/forms';


@Component({
  selector: 'app-imageurls',
  templateUrl: './imageurls.component.html',
  styleUrls: ['./imageurls.component.scss']
})
export class ImageurlsComponent implements OnInit {

  imageurls=[];
  formGroup;
  imgurl: string;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    console.log("pageload start");
    this.getAllImageUrls();
    console.log("pageload ends");
  }

  getAllImageUrls()
  {
    this.apiService.getHeaders(this.apiConfig.getEngagementImagesURL)
      .subscribe((res: any) => {
        this.imageurls = res.body.data.engagement_images
        console.log(this.imageurls);
      }, err => {
        console.log(err);
      }
      )
  }

  showModal(targetModal, targetdata)
  {
    this.imgurl = targetdata.value;
    console.log(this.imgurl);

    this.formGroup = this.fb.group({
      imgurl: this.imgurl,
    });

    this.showFrequencyModal(targetModal);
  }

  showFrequencyModal(targetModal){
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }


}
